import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useSnackbar } from "src/utils/useSnackbar";
import { getOneActionPlanKey } from "./useGetOneActionPlan";
import { getAllActionPlanKey } from "./useGetAllActionPlan";
import { getAllActionPlanActionsKey } from "../ActionPlanAction/useGetAllActionPlanAction";

export const useUpdateWithNewElementsActionPlan = (actionPlanID: string | undefined) => {
    const snackbar = useSnackbar();
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (_?: unknown) => {
            if (actionPlanID === undefined) {
                snackbar.forceClose();
                snackbar.setSnackbarProps({
                    type: "error",
                    message: "Missing an ActionPlanID. Please, contact your admin.",
                });
                return;
            }

            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "info",
                message: "Reinitializing... please, wait",
                forceAutoHideInMilisecond: null,
            });

            const url = `/api/action_plans/${actionPlanID}/update-with-new-elements`;
            return loggedInApiCall.post(
                url,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                },
            );
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.refetchQueries([getOneActionPlanKey]),
                queryClient.refetchQueries([getAllActionPlanKey]),
                queryClient.refetchQueries([getAllActionPlanActionsKey]),
            ]);

            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "success",
                message: "Reinitialization done!",
            });
        },
        onError: () => {
            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "error",
                message: "Reinitialization failed, retry?",
            });
        },
    });

    return query;
};
